module.exports = __webpack_public_path__ + "static/media/headerPicRight1black.61bda2f0.svg";